export {default as Alerts} from './Alerts.connect';
